import { Button } from "react-bootstrap";

function NumberButton({ number, onClick, color, height, backgroundColor, minWidth, disabled, background }) {
    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            style={{
                backgroundColor: '#fff',
                minWidth: minWidth ? minWidth : "",
                width: '100%',
                height: height ?? 80,
                borderRadius: 0,
                border: '0.3px solid #eee',
                color: color ?? ' #1a1a00',
                fontSize: '18px',
                background: background ? background : "#fff"
            }}
        >
            {number}
        </Button>
    )
}

export default NumberButton;